import Vue from 'vue'
import eventBus from '@/plugins/eventbus'
import {
  EVENT_GA_AVAILABLE,
  EVENT_LOGIN_AFTER,
  EVENT_LOGOUT_AFTER
} from '@/plugins/eventbus'
import store from '@/plugins/store'
import router from '@/plugins/router'

Vue.prototype.$ga = new Vue()

eventBus.$on(EVENT_GA_AVAILABLE, (data) => {
  // console.log('ga is now available', data);
  if (!data.ga) {
    console.log('ERROR: GA code is not available!');
    return;
  }
  window.ga('create', data.ga, 'auto');
  window.ga(function (tracker) {
    Vue.prototype.$ga.tracker = tracker;
    // Tracker is now ready
    tracker.set('anonymizeIp', true)
    Vue.prototype.$ga.updateTrackerBasics();
    Vue.prototype.$ga.send({
      hitType: 'pageload'
    })
  });
});

eventBus.$on(EVENT_LOGIN_AFTER, () => {
  Vue.prototype.$ga.updateTrackerBasics();  
});
eventBus.$on(EVENT_LOGOUT_AFTER, () => {
  Vue.prototype.$ga.updateTrackerBasics();  
});

Vue.prototype.$ga.updateTrackerBasics = function() {
    if (Vue.prototype.$ga.tracker) {
      let userId = store.state.profile ? store.state.profile.uid : null;
      // console.log('Updating tracker basics. UserId: ' + userId);
      Vue.prototype.$ga.tracker.set('userId', userId)
    } else {
      // console.log('Tracker not available');
    }
};

Vue.prototype.$ga.send = function (data) {
  if (!window.ga) {
    console.log('ga not available (yet)');
    return;
  }
  var location = window.location.href;
  let queryIdx = location.indexOf('?');
  if (queryIdx > 0) {
    location = location.substring(0, queryIdx - 1)
  }
  let gaData = {
    page: router.currentRoute ? (router.currentRoute.meta && router.currentRoute.meta.gaPageFn ? router.currentRoute.meta.gaPageFn(router.currentRoute) : router.currentRoute.path) : null,
    location: location,
    ...data,
  }
  // console.log(gaData)
  window.ga('send', gaData);
}

export default Vue.prototype.$ga
